import { observer } from 'mobx-react-lite'
import { CopyContent as CopyContentIcon } from 'blaze-ui/icons/36'
import { Action, ActionProps } from './Action'
import { DOMSerializer } from 'prosemirror-model'
import { useProseInstance } from 'providers/ProseInstanceProvider'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useScheduledPost } from 'hooks/queries/scheduledPosts/useScheduledPost'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Copy } from 'blaze-ui/icons'

export const CopyContent = observer(({ ...props }: ActionProps & { scheduledPostId?: number }) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const proseInstance = useProseInstance()
  const { data: scheduledPost } = useScheduledPost({ id: props.scheduledPostId })

  const handleClick = () => {
    if (scheduledPost?.content) {
      const clipboardItem = new ClipboardItem({
        'text/plain': new Blob([scheduledPost.content], { type: 'text/plain' }),
      })
      navigator.clipboard.write([clipboardItem]).then(() => {
        showToastMessage('Post content copied to your clipboard!')
      })
      return
    }

    const { currentView } = proseInstance
    if (!currentView) return

    const doc = currentView.state.doc

    const serializer = currentView.someProp('clipboardSerializer') || DOMSerializer.fromSchema(currentView.state.schema)
    let fragment = serializer.serializeFragment(doc.content)
    let tmp = document.createElement('div')
    tmp.appendChild(fragment)

    const clipboardItem = new ClipboardItem({
      'text/html': new Blob([tmp.innerHTML], { type: 'text/html' }),
      'text/plain': new Blob([tmp.innerHTML], { type: 'text/plain' }),
    })

    navigator.clipboard.write([clipboardItem]).then(() => {
      showToastMessage('Doc contents copied!')
    })
  }
  return <Action icon={isSystemRedesignEnabled ? Copy : CopyContentIcon} onPress={handleClick} {...props} />
})
